/**
 * Film page, phone and cue helpers. Loaded after film-showcase.js. Does not touch its internals.
 * 0. Intro cue: "(Scroll)" becomes "↓ Scroll" (same arrow style as the "↑ Intro" button). The text stays editable in the theme editor.
 * 1. Scroll cue on the project list, hidden after the first project change.
 * 2. Swipe reacts while the finger moves (not only when it lifts), by sending the same key press the page already understands.
 * 3. Arrival: the page always opens on the intro. The black cover (snippets/clz-film-cover.liquid) is lifted once fonts and layout
 *    are settled, after putting the scroll back at the top if the browser moved it. A deep link (?project=) is left alone.
 * 4. Phone glide: the swipe keeps its natural momentum. If it comes to rest between the intro and the project list, the page
 *    glides the rest of the way (forward after a short swipe, back only after a clear swipe up).
 */
(function () {
  'use strict';
  var root = document.getElementById('film-root');
  if (!root) return;
  var touch = window.matchMedia && window.matchMedia('(hover: none)').matches;
  var deeplink = /[?&]project=/.test(location.search);

  var heroCue = root.querySelector('.hero-text .cue');
  if (heroCue) {
    var label = heroCue.textContent.replace(/^[\s(↓]+|[\s)]+$/g, '');
    if (label) heroCue.textContent = '↓ ' + label;
  }

  var cue = document.getElementById('pcue');
  var count = document.getElementById('count');
  if (cue) {
    var t = cue.querySelector('.pcue__t');
    if (t) t.textContent = (touch ? cue.getAttribute('data-touch') : cue.getAttribute('data-mouse')) || '';
    if (count && window.MutationObserver) {
      var obs = new MutationObserver(function () { cue.classList.add('is-off'); obs.disconnect(); });
      obs.observe(count, { childList: true, characterData: true, subtree: true });
    }
  }

  if (!deeplink) {
    try { history.scrollRestoration = 'manual'; } catch (e) {}
    var touched = false, n = 0;
    ['touchstart', 'wheel', 'keydown', 'mousedown'].forEach(function (ev) {
      window.addEventListener(ev, function () { touched = true; }, { passive: true, once: true, capture: true });
    });
    var toIntro = function () {
      if (touched || window.scrollY <= 2) return;
      window.scrollTo(0, 0);
      window.dispatchEvent(new Event('scroll'));
    };
    var iv = setInterval(function () {
      n++;
      if (touched || n > 24) { clearInterval(iv); return; }
      toIntro();
    }, 100);

    var reveal = function () {
      toIntro();
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { if (window.__clzUncover) window.__clzUncover(); });
      });
    };
    var fonts = document.fonts && document.fonts.ready ? document.fonts.ready : Promise.resolve();
    Promise.race([fonts, new Promise(function (r) { setTimeout(r, 1200); })]).then(reveal, reveal);
  }

  if (!touch) return;

  // 4. Glide between the intro (scroll 0) and the project list (scroll = one screen).
  var finger = false, idle = null, rest = 0, gliding = false;
  var screenH = function () { return document.documentElement.scrollHeight - window.innerHeight; };
  window.addEventListener('touchstart', function () { finger = true; clearTimeout(idle); }, { passive: true });
  window.addEventListener('touchend', function () { finger = false; schedule(); }, { passive: true });
  window.addEventListener('touchcancel', function () { finger = false; schedule(); }, { passive: true });
  window.addEventListener('scroll', function () { if (!gliding) schedule(); }, { passive: true });
  function schedule() {
    clearTimeout(idle);
    idle = setTimeout(settle, 140);
  }
  function settle() {
    if (finger || gliding || document.body.classList.contains('engaged')) return;
    if (document.getElementById('ov') && document.getElementById('ov').classList.contains('open')) return;
    var h = screenH(), y = window.scrollY;
    if (h < 100 || y < 4 || y > h - 4) { rest = y > h / 2 ? h : 0; return; }
    var target = y > (rest === 0 ? h * 0.15 : h * 0.85) ? h : 0;
    gliding = true;
    window.scrollTo({ top: target, behavior: 'smooth' });
    var tries = 0;
    var watch = setInterval(function () {
      tries++;
      if (Math.abs(window.scrollY - target) < 2 || tries > 30) {
        clearInterval(watch);
        gliding = false;
        rest = target;
        window.dispatchEvent(new Event('scroll'));
      }
    }, 50);
  }

  // 2. Swipe over the project list.
  var startY = null, fired = false;
  var ignore = '#switch, #ov, #lb, #toTop, #cats';
  window.addEventListener('touchstart', function (e) {
    fired = false;
    startY = document.body.classList.contains('engaged') && e.target.closest && !e.target.closest(ignore) ? e.touches[0].clientY : null;
  }, { passive: true, capture: true });
  window.addEventListener('touchmove', function (e) {
    if (startY === null || fired) return;
    var dy = startY - e.touches[0].clientY;
    if (Math.abs(dy) >= 24) {
      fired = true;
      window.dispatchEvent(new KeyboardEvent('keydown', { key: dy > 0 ? 'ArrowDown' : 'ArrowUp', bubbles: true }));
    }
  }, { passive: true, capture: true });
  window.addEventListener('touchend', function (e) {
    if (fired) e.stopImmediatePropagation();
    fired = false; startY = null;
  }, { passive: true, capture: true });
})();